export default function isHostComponent(_0x5728b3){return typeof _0x5728b3==='string';}